<template>
  <div class="container-item-param-info" :class="{'param-ativo': item.ativo}">
    <div>
      <v-img v-if="item.fotoEmpresa"
             :src="createUrl(item.fotoEmpresa)"
             class="foto-empresa"
             aspect-ratio="4/3"
             lazy-src="/images/loading.gif"
      />
      <v-img v-else
             src="/images/avatares/avatar-padrao.png"
             class="foto-empresa"
             aspect-ratio="4/3"
             lazy-src="/images/loading.gif"
      />
    </div>
    <label class="ml-2">{{ item.nomeConfiguracao }}</label>
    <color-select
        style="margin-left: 50px"
        class="cor-select-custom"
        apenas-visualizar
        :cor-selecionada="item.corPrimaria"/>
    <color-select
        class="ml-5 cor-select-custom"
        apenas-visualizar
        :cor-selecionada="item.corSecundaria"/>
    <color-select
        class="ml-5 cor-select-custom"
        apenas-visualizar
        :cor-selecionada="item.corTerciaria"/>
    <div class="ml-5">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon color="primary" class="mr-2" @click="acaoSelecionarParametro">
            <v-icon>check_circle</v-icon>
          </v-btn>
        </template>
        Ativar parâmetro
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon color="primary" class="mr-2" @click="acaoEditarParametro">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        Editar parâmetro
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon color="red" @click="acaoRemoverParametro">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        Remover parâmetro
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import ColorSelect from '@/views/components/ColorSelect.vue'

export default {
    name: 'ParametrosItem',
    components: {ColorSelect},
    props: {
        item: Object
    },
    methods: {
        acaoSelecionarParametro() {
            this.$emit('acaoSelecionarParametro', this.item)
        },
        acaoEditarParametro() {
            this.$emit('acaoEditarParametro', this.item)
        },
        acaoRemoverParametro() {
            this.$emit('acaoRemoverParametro', this.item)
        }
    }
}
</script>

<style scoped lang="stylus">

.container-item-param-info
  display flex
  align-items center
  padding 5px
  border-bottom 1px solid #ddd

.container-item-param-info:hover
  cursor pointer
  background-color #eee

.param-ativo
  background-color #84E296
  color white

.param-ativo:hover
  background-color #84E296

.cor-select-custom >>> .component-cor
  border 2px solid #1e1e1e !important
  border-radius 10px !important

.foto-empresa
  border-radius 50%
  border 2px solid #eee
  height 50px
  width 50px

</style>